import React from 'react';
import bowser from 'yola-bowser';
import PropTypes from 'prop-types';
import { Popover, PopoverContent, PopoverTrigger } from '../../popover';

const withPopover = (Component) => {
  const Wrapped = ({ popoverProps, disabled = false, ...restProps }) => {
    const isTouchDevice = bowser.mobile || bowser.tablet;

    if (isTouchDevice || disabled) {
      return <Component disabled={disabled} {...restProps} />;
    }

    return (
      <Popover
        title={popoverProps.title}
        hotkey={popoverProps.hotkey}
        description={popoverProps.content}
        placement="bottom-right"
      >
        <PopoverTrigger>
          <Component {...restProps} />
        </PopoverTrigger>
        <PopoverContent />
      </Popover>
    );
  };

  Wrapped.propTypes = {
    disabled: PropTypes.bool,
    popoverProps: PropTypes.shape({
      title: PropTypes.string,
      hotkey: PropTypes.string,
      content: PropTypes.string.isRequired,
    }).isRequired,
  };

  return Wrapped;
};

withPopover.propTypes = {
  Component: PropTypes.element,
};

export default withPopover;
